import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby-plugin-react-intl';

import arrow from '../../../../images/arrow-white_right.svg';
import Image from '../../../Core/Image';

export const StyledListItem = styled.li`
  background-color: ${themeGet('colors.black')};
  &.wide {
    grid-column: span 1;

    @media only screen and (min-width: 535px) {
      grid-column: span 2;
    }
  }
`;

export const Card = styled.article`
  position: relative;
  min-height: 290px;
  max-height: 400px;
  width: 100%;
  height: 100%;
  background-color: ${themeGet('colors.black')};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
    min-height: 290px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    min-height: 260px;

    img {
      min-height: 260px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    min-height: 380px;
  }
`;

export const CardImage = styled(Image)`
  height: 100%;
  width: 100%;
  background-color: ${themeGet('colors.black')};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    min-height: 285px;
  }
`;

export const StyledLink = styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
`;

export const Content = styled.div`
  margin-top: auto;
  height: auto;
  max-height: 100%;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 15px 15px 5px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding: 30px;
  }
`;

export const Title = styled.div`
  font-stretch: normal;
  font-style: normal;
  color: ${themeGet('colors.white')};
  overflow: hidden;
  font-weight: ${themeGet('fontWeights.medium')};
  font-size: 1rem;
  line-height: 1.43;
  letter-spacing: -0.08px;
  margin-bottom: 1.25rem;
  min-height: 86px;

  p {
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    margin-bottom: inherit;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 315px;

    ${StyledListItem}.wide & {
      max-width: 50%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    min-height: 115px;
    max-width: 350px;
    font-size: 24px;
    line-height: 1.33;
    letter-spacing: -0.13px;
  }

  ${StyledListItem}.wide & {
    @media only screen and (min-width: 535px) {
      font-size: 1.5rem;
    }
  }
`;

export const HoverLink = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 300ms;
  height: 24px;
  margin-top: 5px;
  margin-bottom: 0;
  color: ${themeGet('colors.white')};
  font-weight: ${themeGet('fontWeights.normal')};
  letter-spacing: normal;
  line-height: 2.05;
  font-size: 0.875rem;

  &::after {
    content: '';
    background-image: url(${arrow});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    height: 8px;
    width: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: -30px;

    ${Card}:hover & {
      margin-bottom: 15px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    height: 24px;
    margin-top: 30px;
    margin-bottom: -55px;
    font-size: 14px;
    line-height: 1.33;
    letter-spacing: 1.8px;
  }
`;
